/**
 * Funzioni pure di formattazione — formato italiano.
 * Nessuna dipendenza esterna, nessun side effect.
 */

const MONTHS_IT = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

/**
 * Formatta un periodo di fatturazione da date ISO.
 * @param {string} startDate - es. "2026-01-01"
 * @param {string} endDate   - es. "2026-01-31"
 * @returns {string} es. "gen-26" oppure "gen-26 / mar-26"
 */
export const formatPeriod = (startDate, endDate) => {
  try {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const startMonth = MONTHS_IT[start.getMonth()];
    const endMonth = MONTHS_IT[end.getMonth()];
    const startYear = String(start.getFullYear()).slice(-2);
    const endYear = String(end.getFullYear()).slice(-2);

    if (startMonth === endMonth && startYear === endYear) {
      return `${startMonth}-${startYear}`;
    }
    return `${startMonth}-${startYear} / ${endMonth}-${endYear}`;
  } catch {
    return `${startDate} - ${endDate}`;
  }
};

/**
 * Formatta un numero nel formato italiano con separatore migliaia (.) e decimali (,).
 * @param {number|null|undefined} num
 * @param {number} decimals - cifre decimali (default 2)
 * @returns {string} es. "7.288,48"
 */
export const formatNumber = (num, decimals = 2) => {
  if (num === null || num === undefined || isNaN(num)) return '0,00';
  return new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true,
  }).format(num);
};

/**
 * Formatta un importo in euro.
 * @param {number} num
 * @returns {string} es. "€7.288,48"
 */
export const formatEuro = (num) => `€${formatNumber(num, 2)}`;

/**
 * Formatta un prezzo unitario a 6 decimali (formato italiano).
 * @param {number|null|undefined} num
 * @returns {string} es. "0,164111"
 */
export const formatPrezzoUnitario = (num) => {
  if (num === null || num === undefined || isNaN(num)) return '0,000000';
  return num.toLocaleString('it-IT', {
    minimumFractionDigits: 6,
    maximumFractionDigits: 6,
  });
};
